module.exports = __webpack_public_path__ + "static/campaign-logo-448b1fa9d1a2e8c8e66825e8a6f0a26b.svg";